module.exports = __webpack_public_path__ + "img/rotate.40d43b74.svg";